/**
 * Fixed row height for large virtualized XLSX previews in SpreadsheetNote.
 * Must match `_variables.scss` `$xlsx-preview-row-height` / `_cell.scss` (virtual + natural row 0)
 * and scroll position math in `xlsxViewerScrollToMappedCell.ts`.
 * Tall enough for grid-mapping indicator chips (row 0) when they wrap.
 */
export const XLSX_PREVIEW_VIRTUAL_ROW_HEIGHT = 64;
